import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import style from './NavigationTabs.module.scss';

export interface NavigationTab {
  to: string;
  title: string;
  description?: string;
}

interface Props {
  tabs: NavigationTab[];
  className?: string;
}

const NavigationTabs = ({ tabs, className }: Props) => (
  <div className={classNames(style.tabs, className)}>
    {tabs.map(tab => (
      <NavLink
        className={style.tab}
        activeClassName={style.tab__active}
        isActive={(match, location) =>
          match && location && match.url === location.pathname
        }
        to={tab.to}
        key={tab.to}
      >
        <FormattedMessage id={tab.title} defaultMessage={tab.title} />
        {!!tab.description && (
          <div className={style.description}>
            <FormattedMessage
              id={tab.description}
              defaultMessage={tab.description}
            />
          </div>
        )}
      </NavLink>
    ))}
  </div>
);

export default NavigationTabs;
